import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import Pusher from 'pusher-js';
import { getJwt } from './jwtLocalstorage';
import { getWtaiExpressUrl } from './helpers';
// PUSHER CHANNEL EVENTS
var CHANNEL_CONNECTED_EVENT = 'pusher:subscription_succeeded';
export var CHANNEL_UPLOAD_PAPER_EVENT = 'uploadPaper';
var CHANNEL_UNSUBSCRIBE_EVENT = 'pusher:unsubscribe';

// PUSHER GLOBAL EVENTS
var PUSHER_STATE_CHANGE_EVENT = 'state_change';
var PUSHER_CONNECTED_EVENT = 'connected';
var PUSHER_STATE_DISCONNECTED = 'disconnected';
var PUSHER_STATE_UNAVAILABLE = 'unavailable';
var PusherClient = /*#__PURE__*/_createClass(function PusherClient() {
  var _this = this;
  _classCallCheck(this, PusherClient);
  this.pusher = void 0;
  this.uploadChannel = void 0;
  this.initialize = function (site, apiKey, cluster, onConnect, onDisconnect) {
    var WTAI_EXPRESS_URL = getWtaiExpressUrl(site);
    return new Promise(function (resolve) {
      _this.pusher = new Pusher(apiKey, {
        authEndpoint: "".concat(WTAI_EXPRESS_URL, "/auth"),
        auth: {
          headers: {
            'Cache-Control': 'no-store',
            Authorization: "Bearer ".concat(getJwt())
          }
        },
        cluster: cluster
      });
      if (_this.pusher) {
        _this.pusher.connection.bind(PUSHER_STATE_CHANGE_EVENT, function (state) {
          if (state === PUSHER_STATE_DISCONNECTED || state === PUSHER_STATE_UNAVAILABLE) {
            onDisconnect();
          }
        });
        _this.pusher.connection.bind(PUSHER_CONNECTED_EVENT, function () {
          onConnect();
          resolve(void 0);
        });
      }
    });
  };
  this.subscribe = function (channelName) {
    return new Promise(function (resolve, reject) {
      if (_this.pusher) {
        _this.uploadChannel = _this.pusher.subscribe(channelName);
        _this.uploadChannel.bind(CHANNEL_CONNECTED_EVENT, function () {
          resolve(void 0);
        });
      }
    });
  };
  this.unsubscribe = function (channelName) {
    return new Promise(function (resolve, reject) {
      if (_this.pusher && _this.uploadChannel) {
        _this.pusher.disconnect();
        _this.pusher.unbind_all();
        if (channelName) {
          _this.pusher.unsubscribe(channelName);
        }
        _this.uploadChannel.unbind(CHANNEL_UNSUBSCRIBE_EVENT);
        _this.uploadChannel = undefined;
        resolve(void 0);
      } else {
        reject();
      }
    });
  };
});
export default PusherClient;